/**
 * FindingMatcher — Cliente del endpoint /findings/match.
 *
 * Dado un texto descriptivo de los hallazgos actuales del paciente, devuelve
 * los patrones clínicos más similares semánticamente. Complementa al
 * PatternMatcher exacto: este último dispara solo cuando se cumplen todos
 * los criterios; el matching semántico sugiere candidatos aunque falte uno.
 */

import { authService } from '../auth/AuthService';

export interface PatternMatch {
  pattern_id: string;
  pattern_name: string;
  urgency: 'immediate' | 'delayed' | 'minor' | 'expectant' | 'deceased';
  condition: string;
  similarity: number; // 0..1
}

export async function matchFindings(text: string, limit = 5): Promise<PatternMatch[]> {
  if (!authService.isAuthenticated) return [];
  if (!text.trim()) return [];
  try {
    return await authService.request<PatternMatch[]>('/findings/match', {
      method: 'POST',
      body: JSON.stringify({ text, limit }),
    });
  } catch (error) {
    console.warn('[FindingMatcher] backend no disponible:', error);
    return [];
  }
}
